export default function WithdrawalsTableShimmer() {
    return (
        <div className="mx-auto pl-5">
            <div className="overflow-x-auto rounded-lg">
                <table className="w-full border-collapse">
                    <thead className="h-[36px]">
                        <tr className="text-sm bg-weak-600 text-left text-sub-600">
                            <th className="pl-6 text-body-sm font-thin text-sub-600">Amount</th>
                            <th className="text-body-sm font-thin text-sub-600 sm:table-cell">Giv Charges</th>
                            <th className="text-body-sm font-thin text-sub-600">Bank Charges</th>
                            <th className="text-body-sm font-thin text-sub-600">Amount Received</th>
                            <th className="text-body-sm font-thin text-sub-600">Status</th>
                            <th className="text-body-sm font-thin text-sub-600">TimeStamp</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: 8 }).map((_, index) => (
                            <tr key={index} className="border-b hover:bg-gray-50">
                                <td className="mb-5 ml-4 mr-4 mt-6 flex items-center pl-2">
                                    <div className="h-4 w-20 animate-pulse rounded bg-gray-200"></div>
                                </td>
                                <td className="text-strong-600 hidden w-[325px] text-body-sm sm:table-cell">
                                    <div className="h-4 w-16 animate-pulse rounded bg-gray-200"></div>
                                </td>
                                <td className="text-strong-600 w-[180px] text-body-sm">
                                    <div className="h-4 w-16 animate-pulse rounded bg-gray-200"></div>
                                </td>
                                <td className="text-strong-600 text-body-sm">
                                    <div className="h-4 w-20 animate-pulse rounded bg-gray-200"></div>
                                </td>
                                <td className="text-strong-600 text-body-sm">
                                    <div className="h-4 w-16 animate-pulse rounded bg-gray-200"></div>
                                </td>
                                <td className="text-strong-600 text-body-sm">
                                    <div className="h-4 w-24 animate-pulse rounded bg-gray-200"></div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}